<template>
  <CommonPopup
    v-model="visible"
    title="选择单利算法"
    round
    closeable
    position="bottom"
    get-container="body"
    :show-footer="false"
    :z-index="104"
  >
    <div class="single_value_algorithm">
      <div v-for="o in options" :key="o.value" class="algorithm_options">
        <div :class="['algorithm_option', formValues.singleCalType === o.value ? 'active' : '']" @click="handleClickOption(o)">
          <h5 class="algorithm_option_title">
            <b>{{ o.name }}</b>
            <i :class="['iconfont', formValues.singleCalType === o.value ? 'icon-choose_done_surface' : 'icon-choose_none_line']" />
          </h5>
          <p v-if="o.desc1" class="desc1" v-html="o.desc1" />
          <p v-if="o.desc2" class="desc2" v-html="o.desc2" />
          <p v-if="o.desc3" class="desc3" v-html="o.desc3" />
          <div v-if="o.image" class="desc4">
            <p v-html="o.desc4" />
            <img
              :src="o.image"
              alt="algorithm"
              @click.stop="onClickPreviewImage(o.image)"
            >
          </div>
        </div>
      </div>
    </div>
  </CommonPopup>
</template>
<script>
import { ImagePreview } from 'vant'
import CommonPopup from '@/components/common/common-popup/index.vue'
const options = [
  {
    value: 1,
    name: `算法1：逐年算净保费，再算年化单利`,
    desc1: '领取后，净保费减少',
    desc2: '<b>适用场景：</b>存在多次领取的复杂产品，动态看本⾦变化对单利的影响',
    desc3: '<b>缺点：</b>先领保费还是先领利息的处理，会存在偏差',
    desc4: '<b>核心公式：</b>',
    image: 'https://media.winbaoxian.com/assets-uploader/%E7%AE%97%E6%B3%951-1748224760383.png'
  },
  {
    value: 2,
    name: `算法2：先算总利益(含领取)，再算年化单利`,
    desc1: '已领取⾦额，不计利息加和后算⼊总利益',
    desc2: '<b>适用场景：</b>终⾝寿，两全，快返年⾦等险种快速估算',
    desc3: '<b>缺点：</b>忽略资⾦的时间价值，仅适⽤于等额定期交费，其他情况计算结果可能偏离实际',
    desc4: '<b>核心公式：</b>',
    image: 'https://media.winbaoxian.com/assets-uploader/%E7%AE%97%E6%B3%952-1748224760383.png'
  },
  {
    value: 3,
    name: `算法3：先算IRR，再算年化单利`,
    desc1: '',
    desc2: '<b>适用场景：</b>通过IRR反推，⽤于横向⽐较多产品的收益⽔平。仅在趸交时严格成⽴',
    desc3: '<b>缺点：</b>在分期交费或复杂现⾦流中存在偏差',
    desc4: '<b>核心公式：</b>',
    image: 'https://media.winbaoxian.com/assets-uploader/%E7%AE%97%E6%B3%953-1748224760383.png'
  },
]
export default {
  components: {
    CommonPopup
  },
  props: {
    value: Boolean,
    formValues: {
      type: Object,
      default: () => ({})
    },
  },
  data () {
    return {
      options
    }
  },
  computed: {
    visible: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    handleClickOption(o) {
      this.visible = false
      this.$emit('confirm', {
        singleCalType: o.value
      })
    },
    onClickPreviewImage (url) {
      ImagePreview([url])
    }
  }
}
</script>
<style lang="postcss">
.single_value_algorithm {
  padding: 15px;
  font-size: 14px;
  color: #333;
  & .algorithm_options {
    & .algorithm_option {
      margin-bottom: 9px;
      padding-bottom: 15px;
      border: 1px solid #CCC;
      border-radius: 9px;
      & .algorithm_option_title {
        position: relative;
        padding: 12px 15px;
        margin-bottom: 15px;
        font-weight: bold;
        border-top-left-radius: 9px;
        border-top-right-radius: 9px;
        background: #E1ECFF;
        & span {
          font-weight: normal;
        }
        & .iconfont {
          position: absolute;
          right: 15px;
          top: 50%;
          transform: translateY(-50%);
          font-size: 16px;
          font-weight: normal;
          color: #CCC;
        }
      }
      & .desc1 {
        padding-left: 15px;
        color: #0A64FE;
      }
      & .desc2,
      & .desc3,
      & .desc4 {
        padding: 0 15px;
        margin-top: 9px;
        font-size: 13px;
        & b {
          font-weight: bold;
        }
        & img {
          display: block;
          margin: 9px auto 0;
        }
      }
    }
    & .algorithm_option.active {
      border-color: #0A64FE;
      & .algorithm_option_title {
        & .iconfont {
          color: #0A64FE;
        }
      }
    }
  }
}
</style>